/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { LoginHistory, SystemUser, UserLoginHistory } from 'SharedDir/declarations/user';
import { ADMINISTRATION_USER, userUrl } from 'SharedDir/backend/endpoints/administration-user';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { Paginated } from 'SharedDir/declarations/pagination';

export default class UserHistoryApiClass extends SimpleApi<SystemUser, SystemUser> {
  constructor() {
    super(userUrl);
  }

  async getUsersHistory<T>(params?: T) {
    const { data } = (await http({
      ...ADMINISTRATION_USER.HISTORY_LIST,
      params,
    })) as AxiosResponse<Paginated<UserLoginHistory[], any>>;
    return data;
  }

  async getUserHistory<T>(id: number, params?: T) {
    const { data } = (await http({
      ...ADMINISTRATION_USER.HISTORY(id),
      params,
    })) as AxiosResponse<Paginated<LoginHistory[], any>>;
    return data;
  }
}
